import styled from 'styled-components';

export const Separator = styled.div`
  margin: 5px;
  height: 2px;
  width: calc(100% - 10px);
  border-radius: 2px;
  background-color: white;
`;